import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=283886f0&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "./Chat.vue?vue&type=style&index=0&id=283886f0&prod&lang=scss"
import style1 from "./Chat.vue?vue&type=style&index=1&id=283886f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283886f0",
  null
  
)

export default component.exports